import { render, staticRenderFns } from "./CardNotasErros.vue?vue&type=template&id=795d70cb&"
import script from "./CardNotasErros.vue?vue&type=script&lang=js&"
export * from "./CardNotasErros.vue?vue&type=script&lang=js&"
import style0 from "./CardNotasErros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VSpacer})
